<template>
  <div class="index">
    <van-nav-bar
      title="客户跟进任务"
      left-text="返回"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    />
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <van-cell-group inset v-for="(item, index) in list" :key="index" class="list-item" @click="checkDetail(item.id, item.name)">
          <van-cell is-link>
            <template #title>
              <span class="custom-title list-item-title">{{ item.name }}</span>
            </template>
          </van-cell>
          <van-cell>
            <template #title>
              <span class="custom-title list-item-label" style="margin-right: 10px">客户总人数/已跟进人数</span>
            </template>
            <template>
              <span class="list-item-value">
                <van-icon name="friends-o" /> {{ item.total_contact }} / <van-tag plain type="primary"> {{ item.contacted }} </van-tag>
              </span>
            </template>
          </van-cell>
          <van-cell v-if="userPermission < 2">
            <template #title>
              <span class="custom-title list-item-label" style="margin-right: 10px">参与员工人数</span>
            </template>
            <template>
              <span class="list-item-value">
                <van-icon name="manager-o" /> {{ item.employee_ids.length }}
              </span>
            </template>
          </van-cell>
           <van-cell>
            <template #title>
              <span class="custom-title list-item-label" style="margin-right: 10px">客户特征</span>
            </template>
            <template>
              <span class="list-item-value">
                <template v-if="item.filter_params_detail.contact_stages">
                  <van-tag plain type="primary" v-for="(stages, tagIndex) in item.filter_params_detail.contact_stages" :key="tagIndex"> {{ stages.name }} </van-tag>
                </template>
                <template v-if="item.filter_params_detail.tags">
                  <van-tag plain type="primary" v-for="(tag, tagIndex) in item.filter_params_detail.tags" :key="tagIndex"> {{ tag.name }} </van-tag>
                </template>
                <template v-if="item.filter_params_detail.system_tags">
                  <van-tag plain type="primary" v-for="(tag, tagIndex) in item.filter_params_detail.system_tags" :key="tagIndex"> {{ tag.name }} </van-tag>
                </template>
              </span>
            </template>
          </van-cell>
        </van-cell-group>
        <!-- <div class="list-item" v-for="(item, index) in list" :key="index">
          
        </div> -->
        <div v-if="finished && list.length" slot="finished">无更多数据</div>
      </van-list>
      <van-empty
        v-if="finished && !list.length"
        class="custom-image"
        :image="require('../../assets/images/search-no-data.svg')"
        description="暂无数据"
      />
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/plugins/utils'
import { ContactTaskApi } from '@/api/contactTask'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      serchValue: '',
      loading: false,
      finished: false,
      list: [],
      page: 1,
      perPage: 15
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  computed:{
		...mapGetters([
			'userPermission'
		])
	},
  methods: {
    // 返回上一页
    onClickLeft() {
      this.$router.back()
    },
    onLoad () {
      this.loading = true
      ContactTaskApi.index({
        status: 2,
        page: this.page,
        page_size: this.perPage
      }).then(res => {
        this.loading = false
        if(res.data.lists.data.length < this.perPage){
          this.finished = true
          this.loading = false
        }else{
          this.page++
          this.finished = false
          this.loading = false
        }
        this.list = this.list.concat(res.data.lists.data || [])
      })
    },
    checkDetail (id, title) {
      if (this.userPermission < 2) {
        this.$router.push('/contactTask/employee?id=' + id + '&title=' + title)
      } else {
        this.$router.push('/contactTask/contact?contact_task_id=' + id)
      }
      
    },
    onSearch () {},
    clearSerch () {},
    // 路由跳转
    routerPush(e) {
      this.$router.push(e)
    },
  }
}
</script>
<style scoped lang="less">
.index {
  font-size: 14px;
  height: 100%;
  background: #f4f5f7;

  /deep/ .van-nav-bar__content {
    background: #2b63cd;
    color: #fff;
  }

  /deep/ .van-nav-bar .van-icon {
    color: #fff;
  }

  /deep/ .van-nav-bar__text {
    color: #fff;
  }

  /deep/ .van-nav-bar__title {
    color: #fff;
  }

  .content {

    /deep/.van-cell-group {
      margin: 0;
      margin-bottom: 16px;
    }
    // background: #f4f5f7;
    padding: 16px 12px;

    .list-item {
      margin-bottom: 16PX;
      background: #fff;
      box-shadow: 2px 0px 6px rgba(0, 0, 0, .05);


      &-label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #999;
      }

      &-value {
        .van-tag {
          margin-left: 4px;
        }
      }
    }

    .list-item:last-child {
      margin-bottom: 0 !important;
    }
      
  }
}
</style>
